import { render } from "./LandingBlockHowIsFairweyDifferent.vue?vue&type=template&id=4690e42f&scoped=true&lang=pug"
import script from "./LandingBlockHowIsFairweyDifferent.vue?vue&type=script&lang=js"
export * from "./LandingBlockHowIsFairweyDifferent.vue?vue&type=script&lang=js"

import "./LandingBlockHowIsFairweyDifferent.vue?vue&type=style&index=0&id=4690e42f&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4690e42f"]])

export default __exports__